import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { Dropdown, Divider, Grid, Container, Loader } from 'semantic-ui-react';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import { getAds } from '../../fbApi/Ad';
import * as AppActions from '../../actions';
import months from '../../utils/months';
import TabCampaignsComponent from './PresentationComponents/TabCampaignsComponent';
import { retrieveAllAdsInfo } from '../../services/AdServiceManager';
import './AdPreviewV2.css';

import './PresentationBuilder.css';

class AdPreviewV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utms: {},
      data: null,
      showMonthSelector: false,
      showYearSelector: false,
      accounts: null,
      showMonthLoader: false,
      showYearLoader: false,
      doneLoading: false,
      accountOptions: null,
      adAccountName: null,
      adAccountId: null,
      campaignIds: [],
      campaignMonthName: '',
      selectedYear: '',
      selectedAccounts: [],
      campaignId: null,
      campaignName: {
        PRODUCT_CATALOG_SALES: null,
        LEAD_GENERATION: null,
        VIDEO_VIEWS: null,
        LINK_CLICKS: null,
        CONVERSIONS: null,
        MESSAGES: null,
        OUTCOME_TRAFFIC: null,
        OUTCOME_SALES: null
      },
      campaignObjective: null,
      selectedCampaigns: '',
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        MESSAGES: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      },
      campaigns: [],
      years: [],
      previews: [],
      token: props.getFbToken(),
      processing: true
    };
  }

  componentDidMount() {
    this.selectAccount(this.props.accountId, this.props.accountName);
    document
      .querySelector('.App-content')
      .addEventListener('scroll', this.handleScroll);
  }

  onYearSelect = (event, data) => {
    const value = data.value;
    this.selectYear(value);
  };

  onMonthSelect = (event, data) => {
    // get Campaigns, then get ads
    const n = _.find(data.options, (o) => o.value === data.value);
    const ids = n.value.split(',');
    // sends a campaign id, gets back all ads, with adSet info
    const monthYear = n.text;
    this.selectMonth(ids, monthYear);
  };

  getCampaigns = async (id) => {
    try {
      this.setState({ campaigns: null });
      this.setState({ previews: null });
      this.setState({ showYearLoader: true });
      this.setState({ campaigns: [] });
      this.setState({ previews: [] });
      const screen = 'Ad Preview';
      const campaigns = await getCampaigns(id, this.state.token, screen);
      const result = campaigns.data;

      const assocCampaigns = [];
      const campaignMonths = [];
      const years = [];

      _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: []
        };
      });

      _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);

        const existentYear = years.filter((item) => item.text === year);

        if (existentYear.length === 0) {
          years.push({
            value: year,
            text: year
          });
        }

        assocCampaigns[year + month].month = month;
        assocCampaigns[year + month].year = year;
        assocCampaigns[year + month].ids.push(campaign.id);
      });

      _.mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = _.map(campaignMonths, (op, index) => {
        const month = months.filter((item) => item.shortName === op.month);

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          year: op.year
        };
      });

      this.setState({
        data: result,
        campaigns: campaignOpts,
        filteredCampaigns: campaignOpts,
        showYearSelector: true,
        showYearLoader: false,
        years
      });

      return campaignOpts;
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  getAds = async (ids) => {
    this.resetState();
    this.setState({
      campaignIds: ids,
      showAdsLoading: true
    });

    const allCampaigns = await Promise.all(
      _.map(ids, async (id) => {
        const campaign = await getCampaign(id, this.state.token);

        const campaignObjective = campaign.objective;
        const cn = this.state.campaignName;
        cn[campaignObjective] = campaign.name.replace(/_/g, ' ');
        this.setState({ campaignName: cn });
        const resultAds = await getAds(campaign.id, this.state.token);
        const ads = resultAds.data;

        const previewObjects = ads.map(async (ad) => ({
          ...ad,
          ad_id: ad.id,
          name: ad.name,
          campaignObjective
        }));

        return Promise.all(previewObjects);
      })
    );

    const ccm = this.state.campaignMonth;
    const selectedAds = {
      LINK_CLICKS: [],
      VIDEO_VIEWS: [],
      LEAD_GENERATION: [],
      PRODUCT_CATALOG_SALES: [],
      CONVERSIONS: [],
      MESSAGES: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };
    const qcProcess = {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      },
      MESSAGES: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_TRAFFIC: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_SALES: {
        totalAds: 0,
        totalQC: 0
      }
    };
    _.forEach(allCampaigns, (c) => {
      if (c[0] && ccm[c[0].campaignObjective]) {
        ccm[c[0].campaignObjective] = ccm[c[0].campaignObjective].concat(c);
        selectedAds[c[0].campaignObjective] = selectedAds[
          c[0].campaignObjective
        ].concat(c.map((ad) => ({ id: ad.ad_id, name: ad.name })));
        qcProcess[c[0].campaignObjective].totalAds =
          selectedAds[c[0].campaignObjective].length;
      }
    });
    this.props.actions.updateSelectedCustomAds(selectedAds);
    console.log(selectedAds);
    this.props.actions.initCampaignTotalAds(qcProcess);

    const allIds = [];
    Object.keys(selectedAds).forEach((o) => {
      selectedAds[o].forEach((ad) => allIds.push(ad.id));
    });
    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));
    this.setState({
      doneLoading: true,
      showAdsLoading: false,
      campaignMonth: ccm,
      allAdsInfo: allAdsInfo.ads,
      processing: false
    });
  };

  selectAccount = (accountId, accountName) => {
    this.setState({
      selectedAccounts: [
        ...this.state.selectedAccounts,
        { value: accountId, name: accountName }
      ],
      selectedYear: '',
      adAccountId: accountId,
      adAccountName: accountName,
      doneLoading: false,
      showMonthSelector: false,
      showAdsLoading: false,
      showDropdownLoading: false,
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        MESSAGES: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      },
      campaigns: []
    });
    return this.getCampaigns(accountId);
  };

  selectYear = (value) => {
    const filteredCampaigns = this.state.campaigns.filter(
      (val) => val.year === value
    );
    this.setState({
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedYear: value,
      doneLoading: false,
      showAdsLoading: false,
      showDropdownLoading: false,
      selectedCampaigns: ''
    });

    this.resetState();
  };

  selectMonth = (ids, monthYear) => {
    const accountId = this.state.selectedAccounts[0].value;
    this.setState({
      campaign_ids: [{ value: ids, text: monthYear, accountId }],
      campaignMonthName: monthYear,
      selectedCampaigns: ids.join(','),
      presentationSaved: null,
      processing: true,
      adTabActiveIndex: [],
      accordionIndex: {
        LINK_CLICKS: -1,
        VIDEO_VIEWS: -1,
        LEAD_GENERATION: -1,
        PRODUCT_CATALOG_SALES: -1,
        CONVERSIONS: -1,
        MESSAGES: -1,
        OUTCOME_TRAFFIC: -1,
        OUTCOME_SALES: -1
      }
    });
    // move this inside a promise in get ads
    this.getAds(ids);
  };
  handleScroll = () => {
    if (!this.props.isScrolling) {
      this.props.actions.adPreviewScrolling(true);
      setTimeout(() => {
        this.props.actions.adPreviewScrolling(false);
      }, 200);
    }
  };
  resetState = () => {
    this.setState({
      previews: [],
      doneLoading: false,
      shareLink: null,
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        MESSAGES: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      }
    });
  };

  renderYearDropdown = (years) => {
    return (
      <Dropdown
        placeholder="Year"
        search
        selection
        className="compliance-year-select"
        value={this.state.selectedYear}
        options={years}
        onChange={this.onYearSelect}
      />
    );
  };

  renderMonthDropdown = (filteredCampaigns) => {
    if (this.state.showMonthSelector) {
      return (
        <Dropdown
          placeholder="Month"
          search
          selection
          value={this.state.selectedCampaigns}
          options={filteredCampaigns}
          onChange={this.onMonthSelect}
        />
      );
    } else if (this.state.showMonthLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };
  render() {
    const { years, filteredCampaigns, campaignMonth } = this.state;

    return (
      <div className="container" onScroll={this.handleScroll}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              {this.renderYearDropdown(years)}
              {this.renderMonthDropdown(filteredCampaigns)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        {!this.state.doneLoading && this.state.showAdsLoading ? (
          <Loader className="active" />
        ) : null}
        {!this.state.doneLoading ? null : (
          <div style={{ width: '100%', height: '100%' }}>
            <TabCampaignsComponent
              campaignMonth={campaignMonth}
              getFbToken={this.props.getFbToken}
              allAdsInfo={this.state.allAdsInfo}
              campaignMonthName={this.state.campaignMonthName}
              selectedAccounts={this.state.selectedAccounts}
              adAccountName={this.state.adAccountName}
              selectedYear={this.state.selectedYear}
              campaign_ids={this.state.campaign_ids}
              utms={this.state.utms}
              setUpdateUrl={false}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const newProps = Object.assign(
    {},
    {
      user: state.user,
      showCheckboxes: state.adPreview.showCheckboxes,
      checkedCampaigns: state.adPreview.checkedCampaigns,
      selectedAds: state.adPreview.selectedAds,
      isScrolling: state.adPreview.isScrolling
    }
  );

  return newProps;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdPreviewV2);



// WEBPACK FOOTER //
// ./src/screens/Presentation/AdPreviewV2.js